
































































































import Vue from 'vue';
import axios from 'axios';

class TrainingClass {
  ID = 0;
  name = '';
  language = '';
  IDGroups = 0;
}

export default Vue.extend({
  name: 'TableTrainings',
  data: () => ({
    languages: [{}],
    modalNew: false,
    training: new TrainingClass(),
    tableData: [new TrainingClass()],
    userGroups: [],
    validForm: false,
    search: '',
    selectedRowID: 0,
    headers: [
      { text: '', value: 'enabled' },
      { text: 'Název', value: 'name', width: '50%' },
      { text: 'Skupina', value: 'groupName', width: '49%' },
      { text: '', value: 'language', width: '5em' },
    ],
    rules: {
      required: (value: string) => !!value || 'Pole je povinné',
      number: (value: string) => {
        const pattern = /^\d+$/;
        return pattern.test(value) || 'Hodnota musí být číslo!!!';
      },
    },
  }),
  watch: {
    '$store.state.trainingUpdate'() {
      if (this.$store.state.trainingUpdate !== 0) {
        this.dataLoad(this.$store.state.trainingUpdate);
        this.$store.commit('trainingUpdate', 0);
      }
    },
  },
  mounted() {
    this.$store.commit('currentTraining', {});
    this.dataLoad(0);
    this.languagesLoad();
    this.userGroupsLoad();
  },
  methods: {
    trainingNew() {
      this.training.name = '';
      this.training.language = '';
      this.training.IDGroups = 0;
      this.modalNew = true;
      this.$nextTick(function () {
        (this.$refs.newTrainingForm as Vue & { validate: () => boolean }).validate();
      });
    },
    dataSave() {
      if ((this.$refs.newTrainingForm as Vue & { validate: () => boolean }).validate() !== true) {
        this.$store.commit('globalMessage', 'Formulář obsahuje chyby!!!');
      } else {
        axios
          .post('/api/v1/training', this.training)
          .then((response) => {
            this.dataLoad(response.data.ID);
          })
          .catch((err) => {
            this.$store.dispatch('catchErrHandler', err);
          });
      }
    },
    // trainingID -1: deleted, 0: noChange, >0: update
    dataLoad(trainingID: number) {
      axios
        .get('/api/v1/training')
        .then((response) => {
          this.tableData = response.data;
          if (trainingID <= 0) {
            if (this.tableData.length > 0) {
              this.selectedRowID = this.tableData[0].ID;
              this.$store.commit('currentTraining', this.tableData[0]);
            }
          } else {
            let training = new TrainingClass();
            for (training of this.tableData) {
              if (training.ID === trainingID) {
                this.$store.commit('currentTraining', training);
                this.selectedRowID = trainingID;
                this.modalNew = false;
                return;
              }
            }
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    languagesLoad() {
      axios
        .get('/api/v1/language')
        .then((response) => {
          this.languages = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    rowClicked(item: TrainingClass) {
      if (this.selectedRowID !== item.ID) {
        this.selectedRowID = item.ID;
        this.$store.commit('currentTraining', { ...item });
      }
    },
    userGroupsLoad() {
      axios
        .get('/api/v1/group')
        .then((response) => {
          this.userGroups = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
  },
});
